import { Button, Col, Row } from "react-bootstrap";
import Form from "../../common/Form";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import './error.css';
import Sidebar from "../../components/Sidebar";

export default function NotFoundPage() {
  const navigate = useNavigate();

  const searchSubmit = (value: any) => {
    // console.log('value:', value);
  }

  return (
      <div id="not-found" className="m-auto">
        <h1>Errore 404</h1>
        <hr />
        <Row>
          <Col id="content" xs={12} lg={9}>
            <h3>La pagina non è stata trovata</h3>
            <div id="not-found-title">Potrebbe essere stata spostata o non essere più raggiungibile</div>
            <div className="py-4">
              <div className="to-home-text">
                Premi sul pulsante per tornare alla home page
              </div>
              <div className="to-home-button-container">
                <Button
                  id="to-home-button"
                  type="button"
                  onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                    e.preventDefault();
                    navigate('/');
                  }}
                >
                  Home
                </Button>
              </div>
            </div>
            <h4 className="pb-4">Oppure</h4>
            <div id="not-found-search-text">Prova a cercare una pagina nel campo di ricerca</div>
            <Form id="not-found-search" formFields={[
              {
                id: 'search',
                name: 'search',
                type: 'search',
                required: true,
                className: 'form-control',
                placeholder: 'Cerca',
                validation: Yup.string().required("Campo obbligatorio"),
              }
            ]} onSubmit={searchSubmit} submitText={<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="22.2571" height="22.2571" fill="#E63F4B"/>
              <path d="M16.3342 14.3891C17.4342 12.8915 18.0839 11.0426 18.0839 9.04196C18.0839 4.04823 14.0357 0 9.04196 0C4.04823 0 0 4.04823 0 9.04196C0 14.0357 4.04823 18.0839 9.04196 18.0839C11.0431 18.0839 12.8925 17.4338 14.3903 16.3333L14.3891 16.3342C14.4301 16.3898 14.4758 16.4431 14.5262 16.4934L19.8824 21.8497C20.4257 22.393 21.3065 22.393 21.8497 21.8497C22.393 21.3065 22.393 20.4257 21.8497 19.8824L16.4934 14.5262C16.4431 14.4758 16.3898 14.4301 16.3342 14.3891ZM16.6929 9.04196C16.6929 13.2674 13.2674 16.6929 9.04196 16.6929C4.81649 16.6929 1.39107 13.2674 1.39107 9.04196C1.39107 4.81649 4.81649 1.39107 9.04196 1.39107C13.2674 1.39107 16.6929 4.81649 16.6929 9.04196Z" fill="#F9F9F9"/>
              </svg>
              }
            />
          </Col>
          <Col id="sidebar" xs={12} lg={3} className="pt-3">
            <Sidebar />
          </Col>
        </Row>
      </div>
  );
}
